import { render } from "./AdminAnalysesList.vue?vue&type=template&id=ef077cac"
import script from "./AdminAnalysesList.vue?vue&type=script&lang=js"
export * from "./AdminAnalysesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__